import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'
import login from '@/page/login'
import register from '@/page/register'
import successRegister from '@/page/successRegister'
import loginEn from '@/page/loginEn'
import registerEn from '@/page/registerEn'
import successRegisterEn from '@/page/successRegisterEn'
import successRegisterMailEn from '@/page/successRegisterMailEn'
import superlogin from '../page/superLogin'
import tokenlogin from '../page/tokenlogin'

import VueRouter from 'vue-router'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: login,

      children: [
        {
          path: 'index',
          name: 'login',
          component: () => import('@/page/login/index')
        }
      ]
    },
    {
      path: '/superlogin',
      component: superlogin,
      children: [
        {
          path: 'superlogin',
          name: 'superlogin',
          component: () => import('@/page/superLogin/index')
        }
      ]
    },
    {
      path: '/tokenlogin',
      component: tokenlogin,
      children: [
        {
          path: 'tokenlogin',
          name: 'tokenlogin',
          component: () => import('@/page/tokenlogin/index')
        }
      ]
    },
    {
      path: '/register',
      component: register,
      children: [
        {
          path: 'index',
          name: 'register',
          component: () => import('@/page/register/index')
        }
      ]
    },
    {
      path: '/successRegister',
      component: successRegister,
      children: [
        {
          path: 'index',
          name: 'successRegister',
          component: () => import('@/page/successRegister/index')
        }
      ]
    },
    {
      path: '/loginEn',
      component: loginEn,
      children: [
        {
          path: 'index',
          name: 'loginEn',
          component: () => import('@/page/loginEn/index')
        }
      ]
    },
    {
      path: '/registerEn',
      component: registerEn,
      children: [
        {
          path: 'index',
          name: 'registerEn',
          component: () => import('@/page/registerEn/index')
        }
      ]
    },
    {
      path: '/successRegisterEn',
      component: successRegisterEn,
      children: [
        {
          path: 'index',
          name: 'successRegisterEn',
          component: () => import('@/page/successRegisterEn/index')
        }
      ]
    },
    {
      path: '/successRegisterMailEn',
      component: successRegisterMailEn,
      children: [
        {
          path: 'index',
          name: 'successRegisterMailEn',
          component: () => import('@/page/successRegisterMailEn/index')
        }
      ]
    },
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: 'home',
          name: 'home',
          component: () => import('@/page/home')
        }
      ]
    },
    {
      path: '/pay',
      name: 'pay',
      component: () => import('@/page/account/pay')
    },
    {
      path: '/payresult',
      name: 'payresult',
      component: () => import('@/page/pay/payresult')
    },
    {
      path: '/paypalresult',
      name: 'paypalresult',
      component: () => import('@/page/pay/paypalresult')
    },
    {
      path: '/quickpay',
      name: 'quickpay',
      component: () => import('@/page/account/quickPay')
    },
    {
      path: '/quickpayresult',
      name: 'quickpayresult',
      component: () => import('@/page/pay/quickPayResult')
    },
    {
      path: '/quickpayen',
      name: 'quickpayen',
      component: () => import('@/page/account/quickPayEn')
    },
    {
      path: '/quickpayenresult',
      name: 'quickpayenresult',
      component: () => import('@/page/pay/quickPayEnResult')
    },
    {
      path: '/account',
      component: Layout,
      children: [
        {// 企业账户总览
          path: 'corporateaccount',
          name: 'corporateaccount',
          component: () => import('@/page/account/corporateAccounts')
        },
        {// 企业账户充值
          path: 'enterpriserecharge',
          name: 'enterpriserecharge',
          component: () => import('@/page/account/enterpriseRecharge')
        },
        {// 企业账户充值
          path: 'companyTransfer',
          name: 'companyTransfer',
          component: () => import('@/page/account/companyTransfer')
        },
        {// 企业账户购买会员
          path: 'purchasemember',
          name: 'purchasemember',
          component: () => import('@/page/account/purchaseMember')
        },
        {// 企业关联账号管理
          path: 'accountmanagement',
          name: 'accountmanagement',
          component: () => import('@/page/account/accountManagement')
        },
        {// 个人账户总览
          path: 'personaloverview',
          name: 'personaloverview',
          component: () => import('@/page/account/personalOverview')
        },
        {// 个人交易明细
          path: 'personalDetailed',
          name: 'personalDetailed',
          component: () => import('@/page/account/personalDetailed')
        },
        {// 企业交易明细
          path: 'enterpriselDetailed',
          name: 'enterpriselDetailed',
          component: () => import('@/page/account/enterpriselDetailed')
        },
        {// 个人账户总览==>充值
          path: 'recharge',
          name: 'recharge',
          component: () => import('@/page/account/recharge')
        },
        {// 个人账户总览==>转账
          path: 'personalTransfer',
          name: 'personalTransfer',
          component: () => import('@/page/account/personalTransfer')
        },
        {// 支付宝充值页面
          path: 'payGateWay',
          name: 'payGateWay',
          component: () => import('@/page/alipayPage/payGateWay')
        }
      ]
    }
  ]
})
